<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal=false
    :close-on-press-escape=false
    width="500px"
    @close="handleClose"
  >
    <div style="padding: 0 14px 20px;">
      {{ getDescInfo(currentRouteType,btnType) }}
    </div>
    <el-form v-if="btnType=='return'" :model="form" :rules="rules"  ref="formRef" label-width="80px">
      <el-form-item label="退回原因" prop="returnReason">
        <el-checkbox-group v-model="form.returnReason">
          <el-checkbox v-for="(item,index) in resonList" :key="index" :label="item.label"/>
        </el-checkbox-group>
      </el-form-item>
      <!-- 自定义输入原因 -->
      <el-form-item v-if="form.returnReason.includes('其他')"  prop="reasonDetail">
        <el-input
          v-model="form.reasonDetail"
          placeholder="请输入原因"
          :rows="4"
          type="textarea"
          maxlength="200"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm">确认</el-button>
    </div>
  </el-dialog>
</template>
    
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import { Options } from '@/components/utils/fixOptions'
export default {
  data() {
    return {
      resonList: Options.return_reason,
      dialogVisible: true, // 控制对话框的显示与隐藏
      cancelResonList: Options.cancel_reason,
      form: {
        returnReason: [],
        reasonDetail: '',
      },
      accountNames: [],
      rules: {
        returnReason:[
          { required: true, message: '请选择退回原因', trigger: 'change' }
        ],
        reasonDetail:[
          { required: true, message: '请输入原因', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    detailList: {
      type: Array,
      default: []
    },
    currentRouteType: {
      type: String,
      default: ""
    },
    btnType: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.accountNames = this.detailList.map(item => item.accountName);
  },
  methods: {
    getDescInfo(pageType,btnType) {
      let str = this.accountNames.length == 0 ? '' : this.accountNames.join('、')
      // this.accountNames.forEach(ele => {
      //   str += `${ele}、`
      // });
      if(btnType == 'sure') {
        return `确定将${str}${pageType=='2'?'信息确认，并提交至分公司审核': '信息审核通过'}?`
      }else {
        return `确定将${str}信息退回至机构内勤管理员`
      }
    },
    // 提交表单
    submitForm() {
      const userIds =  this.detailList.map(item => item.userId)
      const { lifeNode } = this.detailList[0]
      let data = {
        userIds: userIds,
        step: lifeNode,
        result: this.btnType == 'sure' ? '2' : '4' 
      }
      if(this.btnType == 'sure'){
        this.save(data)
      }else {
        data.returnReason = this.form.returnReason
        data.reasonDetail = this.form.reasonDetail
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            this.save(data)
          } else {
            return false;
          }
        });
      }
        
    },
    save(data) {
      api.post(url.confirmOrAudit, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose('refresh');
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: 'error',
              message: res.result.errors[0].error
            });
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        }
      });
    },
    handleClose(flag='') {
      this.form = {
        returnReason: [], 
        reasonDetail: '',
      };
      this.$emit("close");
      flag == 'refresh' && this.$emit("refresh")
    },
  },
};
</script>
  
<style lang="scss" scoped>
.btns {
  margin-top: 30px;
  text-align: center;
}
.el-radio {
  margin-right: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/reInterviewDialog.vue